export const navLinks = [
  { label: 'Funkciók', href: '#funkciok' },
  { label: 'Widget Demó', href: '#widget-demo' },
  { label: 'Analitika', href: '#analitika' },
];

export const heroStats = [
  { icon: 'ShieldCheck', label: 'GDPR kompatibilis' },
  { icon: 'Zap', label: '50ms válaszidő' },
];

export const pipelineSteps = [
  {
    step: '01',
    icon: 'FileText',
    title: 'Katalógus szinkronizálás',
    description: 'JSON + Embeddingek generálása automatikusan. A termékadatok valós időben szinkronizálódnak.',
  },
  {
    step: '02',
    icon: 'Search',
    title: 'Hibrid keresés',
    description: 'Szemantikus + Lexikai keresés egyszerre. A rendszer érti a szándékot, nem csak a kulcsszavakat.',
  },
  {
    step: '03',
    icon: 'SlidersHorizontal',
    title: 'Hard szűrők',
    description: 'Szín, Költségkeret, Nem, Kapcsolat — precíz szűrés, hogy csak a releváns termékek maradjanak.',
  },
  {
    step: '04',
    icon: 'Brain',
    title: 'LLM újrarangsorolás',
    description: 'AI-generált indoklás minden termékhez.',
  },
];

export const widgetProducts = [
  {
    name: 'North Face Parka',
    price: '38 990 Ft',
    match: 73,
    tag: 'Sötétkék',
    aiReason: 'Vízálló, szélálló, -20°C-ig meleg.',
  },
  {
    name: 'Columbia Puffer',
    price: '34 500 Ft',
    match: 87,
    tag: 'Fekete',
    aiReason: 'Könnyű, meleg, strapabíró anyag.',
  },
];

export const devFeatures = [
  { icon: 'Zap', title: '50ms válaszidő', description: 'Edge-optimalizált API' },
  { icon: 'Shield', title: 'CORS biztonság', description: 'Origin-szintű védelem' },
  { icon: 'Clock', title: 'Rate-limit', description: '1000 req/perc/partner' },
  { icon: 'Code', title: 'TypeScript SDK', description: 'Típusbiztos fejlesztés' },
];

export const htmlCode = `<!-- 1 perces integráció -->
<script src="https://cdn.mitvegyek.ai/widget.js"></\/script>
<script>
  MitVegyek.init({
    apiKey: 'mv_live_xxxxxxxxxx',
    partnerId: 'your-shop-id',
    theme: {
      primary: '#0052CC',
      position: 'bottom-right'
    }
  });
</script>`;

export const tsCode = `// Express 5 + TypeScript
import { MitVegyekAPI } from '@mitvegyek/sdk';

const api = new MitVegyekAPI({
  apiKey: process.env.MITVEGYEK_API_KEY
});

// Ajánlások lekérése
const results = await api.recommend({
  query: "sportcipő, kényelmes, 40k alatt",
  filters: { gender: "male", budget: [30000, 50000] },
  limit: 5
});

// results.items → Rangsorolt termékek AI indoklással`;

export const analyticsStats = [
  { icon: 'Sparkles', value: '8.4%', label: 'Átkattintási arány (CTR)', change: '+2.1%' },
  { icon: 'TrendingUp', value: '4.7%', label: 'Konverziós ráta', change: '+1.3%' },
  { icon: 'Eye', value: '2,847', label: 'Widget megnyitások / nap', change: '+18%' },
];

export const revenueData = [
  { name: 'Jan', value: 850 },
  { name: 'Feb', value: 920 },
  { name: 'Már', value: 1100 },
  { name: 'Ápr', value: 1350 },
  { name: 'Máj', value: 1900 },
  { name: 'Jún', value: 2200 },
  { name: 'Júl', value: 2800 },
  { name: 'Aug', value: 3400 },
];

export const priceDistribution = [
  { name: '0-10k', value: 15 },
  { name: '10-20k', value: 25 },
  { name: '20-30k', value: 35 },
  { name: '30-50k', value: 40 },
  { name: '50k+', value: 30 },
];

export const topSearches = [
  { rank: 1, query: 'sportcipő férfi', count: 1247 },
  { rank: 2, query: 'ajándék nőnek', count: 982 },
  { rank: 3, query: 'téli kabát', count: 876 },
  { rank: 4, query: 'futócipő', count: 721 },
  { rank: 5, query: 'alkalmi ruha', count: 654 },
];
